import Http from './../http';

const prefix = '/user-default-item';

export const get = () => {
  return Http.authApi().get(`${prefix}`);
};

export const store = params => Http.authApi().post(`${prefix}`, params);


export const remove = params => Http.authApi().delete(`${prefix}/${params.encrypted_id}`, params);



// WEBPACK FOOTER //
// ./src/js/services/editor/userDefaultItems.js